import { HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ICaseReportListRes } from '@type/response/resCaseRep';
import { ICaseReportAddReq } from '../types/request/reqCaseRep';
import { IUserInfoCreateReq, IUserInfoUpdateReq } from '../types/request/reqUser';
import { IUserInfo, IUserInfoRes } from '../types/response/resUser';
import { InitService } from './_init.service';
import { TOKEN_ENABLED } from './_interceptor';

function getUrl(url: string) {
  return `/api/client/xiao_jing/${url}`
}

@Injectable({
  providedIn: 'root'
})
export class UserApiService {

  private http = inject(InitService)

  // 获取验证码
  public getCodeAPI(phone: string) {
    return this.http.post<{ phone: string }, string>(getUrl('get_code'), { phone }, {
      context: new HttpContext().set(TOKEN_ENABLED, false)
    })
  }

  // 单独校验验证码
  public verifyCodeAPI(code: string, phone: string) {
    return this.http.post<{ code: string, phone: string }, string>(getUrl('auth_code'), { code, phone })
  }

  // 登录请求
  public loginAPI(phone: string, code: string) {
    return this.http.post<{ phone: string, code: string }, { token: string }>(getUrl('login'), { phone, code }, {
      context: new HttpContext().set(TOKEN_ENABLED, false)
    })
  }

  // 获取个人信息
  public getUserInfoAPI() {
    return this.http.post<null, IUserInfoRes>(getUrl('info'), null)
  }

  // 修改个人信息
  public updateUserInfoAPI(params: IUserInfoUpdateReq) {
    return this.http.post<IUserInfoUpdateReq, string>(getUrl('update'), params)
  }

  // 获取当前登录账号所有的绑定联系人数据
  public getUserAllContsInfoAPI() {
    return this.http.post<null, IUserInfo[]>(getUrl('list'), null)
  }

  // 添加联系人
  public addUserContactAPI(params: IUserInfoCreateReq) {
    return this.http.post<IUserInfoCreateReq, string>(getUrl('create'), params)
  }

  // 获取对应联系人的病例报告
  public getUserCaseReportsAPI(user_id: number) {
    return this.http.post<{ user_id: number }, ICaseReportListRes[] | null>(getUrl('report/list'), { user_id })
  }

  // 删除联系人
  public deleteUserContactAPI(params: { ids: number[] }) {
    return this.http.post<{ ids: number[] }, string>(getUrl('delete'), params)
  }

  // 上传病例报告
  public uploadCaseReportAPI(data: File) {
    return this.http.file(data)
  }

  // 病例报告新增
  public addCaseReportAPI(params: ICaseReportAddReq) {
    return this.http.post<ICaseReportAddReq, { id: number }>(getUrl('report/create'), params)
  }

}
